"use strict";

Object.defineProperty(exports, "isLocaleSupported", {
  enumerable: true,
  get: function get() {
    return _isLocaleSupported.isLocaleSupported;
  }
});
Object.defineProperty(exports, "supportedLocales", {
  enumerable: true,
  get: function get() {
    return _locales.locales;
  }
});
exports.translations = void 0;
var translations = require("./messages/index.js");
exports.translations = translations;
var _isLocaleSupported = require("./isLocaleSupported");
var _locales = require("./locales");